import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Route, Redirect, Switch } from "react-router";
import { ConnectedRouter } from "react-router-redux";
import createHistory from "history/createBrowserHistory";
import App from "./containers/App";
import Dashboard from "./containers/Dashboard";
import Segment from "./components/Segment";
import InsightIndex from "./components/Insights";
import Footer from "./containers/Footer";
import Employee from "./containers/Employees/index";
import EmployeeUserStatus from "./containers/Employees/user-status";
import CreateAccount from "./containers/CreateAccount/index";
import Clients from "./containers/Clients";
import EditClientProfileIndex from "./containers/Clients/editIndex";
import MyProfile from "./containers/Profile/Profile";
import UserLogin from "./containers/Auth/Login";
import ResetPasswordContainer from "./containers/Auth/ResetPassword";
import ChangePasswordContainer from "./containers/Auth/ChangePassword";
import CreateClientAccount from "./containers/CreateClientAccount/index";
import InsightTagsContainer from "./containers/Insights/Tags";
import MySettingsContainer from "./containers/Settings/MySettings";
import InsightsFileSettingsContainer from "./containers/Settings/InsightsFile";
import SegmentList from "./containers/SegmentList/Index";
import SegmentDetail from "./containers/NewSegmentDetail/Index";
import SubscriptionInfo from "./containers/Subscriptionsinfo/SubscriptionsInfo";
import TagInfo from "./containers/TagsInfo/TagsInfo";
import ClientBusinessInfoAndUser from "./containers/ClientBusinessInfoAndUser/ClientBusinessInfoAndUser";
import InsightInfo from "./containers/InsightsInfo/Index";
import CampaignsContainer from "./containers/Campaigns/index";
import CreateCampaignsContainer from "./containers/Campaigns/createCampaigns";
import CampaignReportContainer from "./containers/Campaigns/CampaignReport";
import EmailChannelContainer from "./containers/Campaigns/EmailChannelReport";
import SocialChannelContainer from "./containers/Campaigns/SocialChannelReport";
import DisplayChannelContainer from "./containers/Campaigns/DisplayChannelReport";
import TopLinksClicksContainer from "./containers/Campaigns/TopLinksClicks";
import SegmentDistributionContainer from "./containers/Insights/SegmentDistribution";
import PopularPagesContainer from "./containers/Insights/PopularPages";
import FavoritePagesContainer from "./containers/Insights/FavoritePages";
import AudienceBuilderContainer from "./containers/Segment/AudienceBuilderContainer";

import configureStore from "./stores";

import "./index.css";
import "./assets/css/icons/icomoon/styles.css";
import "./assets/css/bootstrap.css";
import "./assets/css/core.css";
import "./assets/css/components.css";
import "./assets/css/colors.css";

import "./main.css";

const history = createHistory();
const reduxDevState =
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
const store = configureStore(history, reduxDevState);

render(
  <Provider store={store}>
    <ConnectedRouter onUpdate={() => window.scrollTo(0, 0)} history={history}>
      <div>
        <Switch>
          <Redirect exact from="/" to="/dashboard" />
        </Switch>
        <Route path="/" component={App} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route
          exact
          path="/dashboard/subscription"
          render={(props) =>
            JSON.parse(localStorage.getItem("session")).roleId < 51 ? (
              <SubscriptionInfo {...props} />
            ) : (
              <Redirect to="/dahboard" />
            )
          }
        />
        <Route
          exact
          path="/dashboard/tags"
          render={(props) =>
            JSON.parse(localStorage.getItem("session")).roleId < 51 ? (
              <TagInfo {...props} />
            ) : (
              <Redirect to="/dashboard" />
            )
          }
        />
        <Route
          exact
          path="/dashboard/clients/:type"
          render={(props) =>
            JSON.parse(localStorage.getItem("session")).roleId < 51 ? (
              <ClientBusinessInfoAndUser {...props} />
            ) : (
              <Redirect to="/dashboard" />
            )
          }
        />
        <Route
          exact
          path="/dashboard/data/:type"
          render={(props) =>
            JSON.parse(localStorage.getItem("session")).roleId < 51 ? (
              <InsightInfo {...props} />
            ) : (
              <Redirect to="/dashboard" />
            )
          }
        />
        <Route
          exact
          path="/segments/builder"
          component={AudienceBuilderContainer}
        />
        <Route exact path="/segment/:step" component={Segment} />

        <Route exact path="/segments/list/:type" component={SegmentList} />
        <Route
          exact
          path="/segments/list/detail/:id"
          component={SegmentDetail}
        />
        <Route path="/segments/list/active/:id" component={SegmentList} />
        <Route path="/employees" exact component={Employee} />
        <Route
          path="/employees/user-status/:id/:pageNumber/:sortColumn/:order"
          exact
          component={EmployeeUserStatus}
        />
        <Route path="/create-internal-account/:id" component={CreateAccount} />
        <Route
          path="/create-client-account/:code"
          component={CreateClientAccount}
        />
        <Route
          path="/create-business-unit-member-account/:code"
          component={CreateClientAccount}
        />
        <Route exact path="/clients" component={Clients} />
        <Route path="/clients/edit" component={EditClientProfileIndex} />
        <Route path="/login" component={UserLogin} />
        <Route path="/logout" component={UserLogin} />
        <Route path="/resetpassword" component={ResetPasswordContainer} />
        <Route path="/changepassword" component={ChangePasswordContainer} />
        <Route path="/myProfile" component={MyProfile} />
        <Route
          exact
          path="/segment-distribution"
          component={SegmentDistributionContainer}
        />
        <Route
          exact
          path="/distribution/pages/popular"
          component={PopularPagesContainer}
        />
        <Route
          exact
          path="/distribution/pages/favorite"
          component={FavoritePagesContainer}
        />
        <Route exact path="/insights" component={InsightIndex} />
        <Route exact path="/insights/:type" component={InsightIndex} />
        <Route exact path="/insights/:type/:kind" component={InsightIndex} />
        <Route path="/insights/tags/:action" component={InsightTagsContainer} />

        <Route path="/settings/tags/:action" component={MySettingsContainer} />
        <Route
          path="/settings/insights"
          component={InsightsFileSettingsContainer}
        />
        <Route exact path="/campaigns" component={CampaignsContainer} />
        <Route
          exact
          path="/campaigns/create"
          render={(props) =>
            JSON.parse(localStorage.getItem("session")).roleId === 1 ||
            JSON.parse(localStorage.getItem("session")).roleId === 5 ? (
              <CreateCampaignsContainer {...props} />
            ) : (
              <Redirect to="/dashboard" />
            )
          }
        />
        <Route
          exact
          path="/campaigns/edit/:id"
          render={(props) =>
            JSON.parse(localStorage.getItem("session")).roleId === 1 ||
            JSON.parse(localStorage.getItem("session")).roleId === 5 ? (
              <CreateCampaignsContainer {...props} />
            ) : (
              <Redirect to="/dashboard" />
            )
          }
        />
        <Route
          exact
          path="/campaigns/report/:id"
          render={(props) => <CampaignReportContainer {...props} />}
        />
        <Route
          exact
          path="/campaigns/report/:id/:channelType/:channelCampaignId/:segmentId/top-links-click"
          render={(props) => <TopLinksClicksContainer {...props} />}
        />
        <Route
          exact
          path="/campaigns/report/:id/email/:channelCampaignId"
          render={(props) => <EmailChannelContainer {...props} />}
        />
        <Route
          exact
          path="/campaigns/report/:id/social/:channelCampaignId"
          render={(props) => <SocialChannelContainer {...props} />}
        />
        <Route
          exact
          path="/campaigns/report/:id/display/:channelCampaignId"
          render={(props) => <DisplayChannelContainer {...props} />}
        />
        <Footer />
      </div>
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root"),
);



// WEBPACK FOOTER //
// ./src/index.js